import React from 'react';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';

/* replace-start */
import './index.less';
/* replace-end */
class Feature13 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    function getItem() {
      const itemLists = dataSource.content.children;
      return itemLists.map((key, index) => {
        const { title, img, ...other } = key;
        return (
          <div {...other} key={index}>
            <div {...img}>
              <img src={img.children} alt="" />
            </div>
            <div {...title}>
              <span dangerouslySetInnerHTML={{ __html: title.children }} />
            </div>
          </div>
        );
      }
      );
    }

    return (
      <OverPack
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.bg} data-edit="image">
          <img src={dataSource.bg.children} width="100%" alt="img" />
        </div>
        <div {...dataSource.page}>
          <TweenOne
            animation={[{
              scale: 1.2,
              duration: 1000,
            }, {
              scale: 1,
              duration: 300,
            }]}
            style={{ transform: 'scale(0)' }}
            {...dataSource.title}
          >
            {
            dataSource.title.children.map(getChildrenToRender)
          }
          </TweenOne>
          <QueueAnim
            delay={300}
            duration={1300}
            type="scaleY"
            {...dataSource.content}
          >
            {getItem()}
          </QueueAnim>
        </div>
      </OverPack>
    );
  }
}
export default Feature13;
